import { z } from 'zod';

export const PO_BOX_REGEX =
  /\b(p\.?\s*o\.?\s+box|post\s+office\s+box|post\s+box|box\s+\d+)\b|\bpob\b|\bp\.o\.b\.|\bpbox\b/i;

export const ADDRESS_ALLOWED_CHARACTERS_REGEX = /^[A-Za-z0-9 #\-/.'&]*$/;

export const streetAddressLineOneValidationMessages = {
  invalid_po_box: `Can't be a PO box.`,
  required: 'Required',
  invalid_characters: "Use only letters, numbers, spaces, #, -, /, ., ', and &",
};

export const streetAddressLineOneSchema = z
  .string()
  .min(1, { error: streetAddressLineOneValidationMessages.required })
  .regex(ADDRESS_ALLOWED_CHARACTERS_REGEX, {
    error: streetAddressLineOneValidationMessages.invalid_characters,
  })
  .refine((value) => !PO_BOX_REGEX.test(value), {
    message: streetAddressLineOneValidationMessages.invalid_po_box,
  });
